import React, { useState, useEffect } from 'react'
import { Button, Modal, ModalBody, ModalFooter } from 'reactstrap'
import { BiX } from 'react-icons/bi'
import CheckBox from 'rc-checkbox'
import BottomScrollListener from 'react-bottom-scroll-listener'

// Folder-page "add existing" picker: choose one or more currently un-foldered
// items to add into the open folder. `getLabel` lets a host derive each row's
// display title (e.g. Library items whose title comes from getTriviaFileName
// rather than a plain `name`).
const SelectTrivvysModal = ({
  open,
  onClose,
  candidates,
  onConfirm,
  title,
  subtitle,
  getLabel,
  onLoadMore,
}) => {
  const [selected, setSelected] = useState([])

  useEffect(() => {
    setSelected([])
  }, [open])

  const list = candidates || []
  const resolveLabel = getLabel ? getLabel : (item) => item.name

  const toggle = (id) => {
    if (selected.includes(id)) {
      setSelected(selected.filter((x) => x !== id))
    } else {
      setSelected([...selected, id])
    }
  }

  const handleConfirm = () => {
    if (!selected.length) {
      return
    }
    if (onConfirm) {
      onConfirm(selected)
    }
  }

  return (
    <Modal isOpen={open} centered>
      <ModalBody className="p-4">
        <div className="d-flex justify-content-between align-items-start">
          <h5 className="folder-modal-title mb-0">
            {title || 'Add existing Trivvys'}
          </h5>
          <BiX
            className="cursor-pointer"
            color="#6c757d"
            size={26}
            onClick={() => onClose()}
          />
        </div>
        {subtitle ? (
          <p className="folder-modal-subtitle mt-1 mb-0">{subtitle}</p>
        ) : null}

        {list.length === 0 ? (
          <div className="my-4 text-center folder-picker-empty">
            No items available to add.
          </div>
        ) : (
          <BottomScrollListener onBottom={onLoadMore ? onLoadMore : () => {}}>
            {(scrollRef) => (
              <div
                ref={scrollRef}
                className="folder-trivvy-pick-list mt-3"
              >
                {list.map((item) => (
                  <div
                    key={item._id}
                    className="folder-trivvy-pick-item cursor-pointer"
                    onClick={() => toggle(item._id)}
                  >
                    <CheckBox
                      checked={selected.includes(item._id)}
                      className="mr-2"
                      onChange={() => toggle(item._id)}
                    />
                    <span className="survey-item-title d-inline folder-trivvy-pick-name">
                      {resolveLabel(item)}
                    </span>
                  </div>
                ))}
              </div>
            )}
          </BottomScrollListener>
        )}
      </ModalBody>

      <ModalFooter className="border-0 pt-0">
        <Button
          className="folder-btn-cancel"
          onClick={() => onClose()}
        >
          Cancel
        </Button>
        <Button
          disabled={!selected.length}
          className="folder-btn-primary"
          onClick={handleConfirm}
        >
          {selected.length ? `Add (${selected.length})` : 'Add'}
        </Button>
      </ModalFooter>
    </Modal>
  )
}

export default SelectTrivvysModal
